import { projectsListT } from "../../redux/reducers/types";

export const deleteItemsAttributeInState = ({
  projectsList,
  attrName,
  attrId,
  itemId,
  projectId,
}: any) => {
  const newProjects: projectsListT[] = [];
  projectsList.map((project: projectsListT) => {
    if (project.id === projectId) {
      const newCurentOption: any = [];
      //@ts-ignore
      const allCurentOptions = project.attributesList[attrName];
      allCurentOptions.rows.map((attr: any) => {
        if (attr.id === attrId) {
          const items = attr.items;
          const newCurrentItems: any[] = [];
          items.map((item: any) => {
            if (item.id !== itemId) {
              newCurrentItems.push(item);
            }
          });
          newCurentOption.push({
            ...attr,
            items: newCurrentItems,
          });
        } else {
          newCurentOption.push(attr);
        }
      });
      newProjects.push({
        ...project,
        attributesList: {
          ...project.attributesList,
          [attrName]: {
            count: allCurentOptions.count,
            rows: newCurentOption,
          },
        },
      });
    } else {
      newProjects.push(project);
    }
  });

  return newProjects;
};
